import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import { addVisibilityWatcher } from "web/script/modules/visibility-watcher";
import "web/script/components/lead-link";
import "web/script/components/tooltip-tippy";

const TOGGLE_BUTTON = "price-history-retailers__toggle-button";
const HISTORY_CELL = ".price-history-retailers__td--history";
const TOGGLE_CELL_OPEN = "price-history-retailers__td--open";
const HIDE_CELL = "price-history-retailers__td--hidden";
const PARENT_ROW_OPEN = "price-history-retailers__body-row--open";
const NEXT_ROW_OPEN = "price-history-retailers__next-row--open";

export default baustein.register("price-history-retailers", {
    /**
     * Handle show/hide of price history
     */
    setupEvents: function(add) {
        add("click", this._onButtonClick);
    },

    _sendEvent(name) {
        analytics.event("price-history", "price-history-table", name, true);
    },

    onInsert() {
        this._removeVisiblityWatcher = addVisibilityWatcher(this.el, (visible) => {
            if (visible) {
                this._removeVisiblityWatcher();
                this._sendEvent("price-history-table-viewed");
            }
        });
    },

    _onButtonClick: function(e) {
        const target = e.target;

        if (target.classList.contains(TOGGLE_BUTTON)) {
            const parentRow = target.parentNode.parentNode;
            const parentCell = target.parentNode;
            const nextRow = parentRow.nextElementSibling;
            const relatedTableCell = nextRow.querySelector(HISTORY_CELL);

            parentRow.classList.toggle(PARENT_ROW_OPEN);
            nextRow.classList.toggle(NEXT_ROW_OPEN);
            parentCell.classList.toggle(TOGGLE_CELL_OPEN);
            relatedTableCell.classList.toggle(HIDE_CELL);
        }
    },

    init() {
        this._sendEvent("price-history-table-loaded");
    },
});
